module.exports = __webpack_public_path__ + "img/icon_catgunner.08de0864.jpg";